import fs from 'fs'
import { getDeployConfiguration } from "../configuration/configuration"
import { createCiConfig } from "../gitlabCi/createGitlabCiConfig"
import { getDiff } from '../util/diff'
import log from 'loglevel'

export type cliCreateCiConfigOptions = {
  deployConfig: string,
  outputFile: string,
  dryRun: boolean,
}

export const cliCreateCiConfig = async (options: cliCreateCiConfigOptions) => {
  const { deployConfig: configFile, dryRun, outputFile } = options
  // TODO DRY RUN
  const deployConfig = await getDeployConfiguration(configFile)
  const newConfig = createCiConfig(deployConfig)
  const outputPath = `${process.cwd()}/${outputFile}`
  const outputExists = fs.existsSync(outputPath)
  const currentConfig = outputExists ? fs.readFileSync(outputPath, 'utf8') : ''
  const diff = getDiff(currentConfig, newConfig)
  if (diff) {
    log.info(`Differences found`)
    if (dryRun) {
      log.info(`Dry run. No changes will be saved. See diff below:`)
      log.info(diff)
    } else {
      log.info(`Saving new config to location ${outputPath}. Please commit new config before deploying.`)
      fs.writeFileSync(outputPath, newConfig)
    }
  } else {
    log.info('There are no changes required in your CI configuration, no actions required. You are ready to deploy.')
  }

}